import { FormattedMessage, useIntl } from 'react-intl';

import { Label } from '@/modules/forms';
import { ALL_USERS_GROUP_ID, createGroupLabel, FormFieldGroups, useGroups, type GroupWithPermissions } from '@/modules/groups';

import { Fields } from '../../../constants';
import { SelectField, type SelectFieldProps } from '../SelectField';

const name = Fields.GROUPS;

export const GroupsField = ({ onChange }: Pick<SelectFieldProps<GroupWithPermissions>, 'onChange'>) => {
    const intl = useIntl();

    const placeholder = intl.formatMessage({ id: 'secret.groups.placeholder' });

    const { api, dataWithLocalizedAllUsersGroup, handleLoadMore, handleSearch, filter } = useGroups({ onlyVisible: true });

    return (
        <SelectField<GroupWithPermissions>
            id={name}
            name={name}
            label={
                <Label>
                    <FormattedMessage id='secret.groups.label' />
                </Label>
            }
            placeholder={placeholder}
            options={dataWithLocalizedAllUsersGroup
                .filter(group => {
                    if (group.id === ALL_USERS_GROUP_ID) {
                        return group.name?.toLocaleLowerCase().includes(filter.toLocaleLowerCase());
                    }

                    return true;
                })
                .map(group => ({
                    value: group.id,
                    entity: group,
                    key: group.id,
                    label: createGroupLabel(group),
                }))}
            onChange={onChange}
            onSearch={handleSearch}
            loading={api.inProgress}
            loadingMore={api.inProgressNext}
            onLoadMore={handleLoadMore}
            hasMore={Boolean(api.nextPageToken)}
            popupShouldIgnoreParentContainer
        >
            {(value, actions) => <FormFieldGroups value={value} onUpdate={actions.onUpdate} onRemove={actions.onRemove} />}
        </SelectField>
    );
};
